import {
    Column,
    Container,
    cssVar,
    DiscountBadge,
    Grid,
    Label,
    Row,
    useAlignments,
    useScreen,
    useSizes,
} from 'metrix-common3';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

const DiscountsContainer = styled(Container)`
    margin-top: 30px;
    background: ${cssVar.colorLightMode};
    border: 1px solid ${cssVar.colorPrimary};
    justify-content: center;
`;

const DiscountContainer = styled(Container)`
    max-height: 85px;
    min-height: 85px;
`;

const DiscountLabel = styled(Label)`
    max-height: 13px;
`;

const CornerRibbon = styled(Container)`
    background: ${cssVar.colorPrimary};
    top: ${({ mobile }) => (mobile ? '93px' : '95px')};
    left: ${({ mobile }) => (mobile ? '-33px' : '-31px')};
    text-align: center;
    line-height: ${({ mobile }) => (mobile ? '15px' : '20px')};
    border: 1px solid ${cssVar.colorPrimary};

    color: #f0f0f0;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    position: relative;
    box-shadow: 0 0 3px rgba(0,0,0,.3);
    max-width: 106px;
    min-width: 106px;
`;

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}

const ProfileDiscounts = (props) => {
    const intl = useIntl();
    const sizes = useSizes();
    const alignments = useAlignments();
    const screen = useScreen();
    const isMobile = screen?.isMobile;

    const getDiscountCodes = () => {
        const allCodes = [];

        if (props.discounts && props.discounts.length > 0) {
            const uniqueCodes = props.discounts.map((discount) => discount.code).filter(onlyUnique);

            const singleCodes = [];
            uniqueCodes.forEach((x) => {
                switch (x) {
                    case 'DISCF':
                    case 'DISCO':
                        singleCodes.push('DISCF');
                        break;
                    case 'DISMP':
                        singleCodes.push('DISMP');
                        break;
                    case 'DISMV':
                        singleCodes.push('DISMV');
                        break;
                    case 'DISNB':
                        singleCodes.push('DISNB');
                        break;
                    case 'DISNC':
                    case 'DISNO':
                        singleCodes.push('DISNC');
                        break;
                    case 'DISSN':
                    case 'ZDSWT':
                        singleCodes.push('DISSN');
                        break;
                    case 'ZDSAB':
                        singleCodes.push('ZDSAB');
                        break;
                    default:
                        singleCodes.push('GENERIC');
                        break;
                }
            });

            return singleCodes.sort().filter(onlyUnique);
        }
        return allCodes;
    };

    const getDiscountBadge = (discount, i, mobile, columnSize) => {
        if (mobile === true && i >= 4) return null;

        // Get translated labels using intl
        const label1 = intl.formatMessage({ id: `Profile_CommonComponents_DiscountBadges.${discount}.label1` });
        const label2 = intl.formatMessage({ id: `Profile_CommonComponents_DiscountBadges.${discount}.label2` });

        return (
            <Column xs={columnSize} nogutter>
                <DiscountContainer
                    horizontalAlignment={alignments.center}
                    top={sizes.xs}
                    bottom={sizes.xs}
                    left={mobile ? sizes.sm : sizes.none}
                >
                    <DiscountBadge code={discount} size={48} />
                    <DiscountLabel
                        size={sizes.none}
                        fontSize={12}
                        lineHeight={13}
                        textAlign={alignments.center}
                        text={`[b]${label1}[b]`}
                    />
                    <DiscountLabel
                        size={sizes.none}
                        fontSize={12}
                        lineHeight={13}
                        textAlign={alignments.center}
                        text={`[b]${label2}[b]`}
                    />
                </DiscountContainer>
            </Column>
        );
    };

    const showDiscounts = props.discounts && props.discounts.length > 0;
    const discountCodes = showDiscounts && getDiscountCodes();
    const discountColumns = showDiscounts && (isMobile ? Math.min(4, discountCodes.length) : discountCodes.length);

    return (
        <Container>
            <CornerRibbon mobile={isMobile}>
                <Label
                    text={intl.formatMessage({ id: 'Profile_CommonComponents_DiscountBadges.discounts' })}
                    size={'custom'}
                    fontSize={isMobile ? '12' : '14'}
                    lineHeight={isMobile ? '17' : '21'}
                    inverse
                />
            </CornerRibbon>
            <DiscountsContainer
                horizontalAlignment={alignments.center}
                verticalAlignment={alignments.center}
                left={sizes.xs}
                right={sizes.xs}
            >
                <Grid>
                    <Row nogutter>
                        {discountCodes.map((discount, i) =>
                            getDiscountBadge(discount, i, isMobile, 12 / discountColumns),
                        )}
                    </Row>
                </Grid>
            </DiscountsContainer>
        </Container>
    );
};

export default ProfileDiscounts;
